import { useFetcher } from '@remix-run/react';
import { useEffect } from 'react';

const useNewsletters = () => {
  const fetcher = useFetcher();

  useEffect(() => {
    fetcher.load('/publications');
  }, []);

  return {
    newsletters: fetcher?.data?.publications,
  };
};

export default useNewsletters;
